export default __webpack_public_path__ + "static/media/grateful-calender.45c0169b.png";